import axios from "axios";
import { SERVER_URL } from "../../config";
import {
  convertYearToAgeByClient,
  getClientDisplayNameById,
  getSelectedClient,
  getSelectedClientAppliesToType,
  MONTH_LIST,
  MONTH_NUM_MAP,
} from "../../common/shared";
import { EXPENSE_ROW } from "../../redux/constants";

export const mapBEExpenseToFE = (expense, index) => {
  return {
    id: expense.id,
    rowType: EXPENSE_ROW,
    editIndex: index,
    name: expense.name,
    mirroredName: expense.name,
    amount: expense.amount.amount,
    totalYearsInflatedAmount: expense.amount.totalYearsInflatedAmount,
    appliesTo: {
      id: expense.appliesTo.appliesToId ? expense.appliesTo.appliesToId : 0,
      name: getClientDisplayNameById(expense.appliesTo.appliesToId),
    },
    appliesToName: getClientDisplayNameById(expense.appliesTo.appliesToId),
    inflationRate: expense.amount.inflationRate / 100.0,
    startYear: expense.date.startYear,
    startMonth: expense.date.startMonth,
    startAge: convertYearToAgeByClient(
      expense.date.startYear,
      getSelectedClient({
        id: expense.appliesTo.appliesToId ? expense.appliesTo.appliesToId : 0,
        name: "HOUSEHOLD",
      }),
      MONTH_LIST[expense.date.startMonth - 1]
    ),
    endYear: expense.date.endYear,
    endMonth: expense.date.endMonth,
    endAge: convertYearToAgeByClient(
      expense.date.endYear,
      getSelectedClient({
        id: expense.appliesTo.appliesToId ? expense.appliesTo.appliesToId : 0,
        name: "HOUSEHOLD",
      }),
      MONTH_LIST[expense.date.endMonth - 1]
    ),
    start: new Date(
      expense.date.startYear,
      expense.date.startMonth - 1,
      expense.date.startMonth - 1 === 11 ? 31 : 1
    ),
    end: new Date(
      expense.date.endYear,
      expense.date.endMonth - 1,
      expense.date.endMonth - 1 === 11 ? 31 : 1
    ),
    endDateValid: true,
    startDateValid: true,
    hasEnding: true,
    scopeType: expense.scopeType,
    isCopy: false,
  };
};

export const mapFEExpenseToBE = (expense, clientId) => {
  return {
    id: expense.id,
    name: expense.name,
    clientId: clientId,
    isCopied: expense.isCopy,
    isEdited: expense.isEdited,
    appliesTo: {
      appliesToId: expense.appliesTo.id,
      appliesToType: getSelectedClientAppliesToType(expense.appliesTo),
    },
    amount: {
      frequency: "MONTHLY",
      amount: expense.amount,
      inflationRate:
        expense.inflationRate !== null ? expense.inflationRate * 100.0 : null,
      futureValue: false,
    },
    date: {
      startDateType: "REGULAR_DATE",
      endDateType: "REGULAR_DATE",
      relativeStartDateNum: 0,
      relativeEndDateNum: 0,
      startYear: expense.startYear,
      endYear: expense.endYear,
      startMonth: parseInt(expense.startMonth),
      endMonth: parseInt(expense.endMonth),
    },
    scopeType: expense.scopeType,
  };
};

export const getExpenseList = (advisorId, clientId) => {
  console.log("Expense API - getExpenseList");

  return new Promise((resolve, reject) => {
    const targetUrl = `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/expenses`;

    axios.get(targetUrl).then((response) => {
      resolve(response.data.payload.map(mapBEExpenseToFE));
    });
  });
};

export const updateExpenseList = (advisorId, clientId, expenseList) => {
  console.log("Expense API - updateExpenseList");

  return new Promise((resolve, reject) => {
    const targetUrl = `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/expenses`;

    const data = expenseList.map(mapFEExpenseToBE);
    axios.post(targetUrl, data).then((response) => {
      resolve(response.data.payload.map(mapBEExpenseToFE));
    });
  });
};

export const batchDeleteExpenses = (advisorId, clientId, expenseIdList) => {
  console.log("Expense API - batchDeleteExpenses");

  return new Promise((resolve, reject) => {
    const targetUrl = `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/expense/batch-delete`;

    axios.post(targetUrl, expenseIdList).then(() => resolve({}));
  });
};
